import React, { useState } from "react";
import Card from '../Card';
import GameOver from '../GameOver';
import "../styles.scss";

const GameBoard = (props) => {
  const cards = props.cardList;
  const [flippedCards, setFlippedCards] = useState([]);
  const [gameOver, setGameOver] = useState(false);

  ///////////// HELPER FUNCTION /////////////
  const shuffle = (array) => {
    let currentIndex = array.length,
      temporaryValue,
      randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  };

  ///////////// SETUP /////////////
  const [cardList, setCardList] = useState(
    shuffle(cards).map((item, index) => {
      return {
        id: index,
        name: item.id,
        flipped: false,
        matched: false,
        icon: item.icon,
      };
    })
  );

  ///////////// GAME LOGIC /////////////
  const handleClick = (name, index) => {
    let currentCard = {
      name,
      index,
    };

    //update card is flipped
    let updateCards = cardList.map((card) => {
      if (card.id === index) {
        card.flipped = true;
      }
      return card;
    });
    let updateFlipped = flippedCards;
    updateFlipped.push(currentCard);
    setFlippedCards(updateFlipped);
    setCardList(updateCards);

    //if 2 cards are flipped, check if they are a match
    if (flippedCards.length === 2) {
      setTimeout(() => {
        check();
      }, 750);
    }
  };

  const check = () => {
    let updateCards = cardList;
    if (
      flippedCards[0].name === flippedCards[1].name &&
      flippedCards[0].index !== flippedCards[1].index
    ) {
      updateCards[flippedCards[0].index].matched = true;
      updateCards[flippedCards[1].index].matched = true;
      isGameOver();
    } else {
      updateCards[flippedCards[0].index].flipped = false;
      updateCards[flippedCards[1].index].flipped = false;
    }
    setCardList(updateCards);
    setFlippedCards([]);
  };

  const isGameOver = () => {
    let done = true;
    cardList.forEach((card) => {
      if (!card.matched) done = false;
    });
    setGameOver(done);
  };

  ///////////// RESTART - REDO SETUP /////////////

  const restartGame = () => {
    setCardList(
      shuffle(cards).map((item, index) => {
        return {
          id: index,
          name: item.id,
          flipped: false,
          matched: false,
          icon: item.icon,
        };
      })
    );

    setFlippedCards([]);
    setGameOver(false);
  };

  ///////////// DISPLAY /////////////

  return (
    <div className="game-board">
      {!gameOver &&
        cardList.map((card, index) => (
          <Card
            key={index}
            id={index}
            name={card.name}
            flipped={card.flipped}
            matched={card.matched}
            clicked={flippedCards.length === 2 ? () => {} : handleClick}
            icon={card.icon}
          />
        ))}
      {gameOver && (
        <GameOver
          restartGame={restartGame}
          activeGame={props.activeGame}
          setIsFinish={props.setIsFinish}
        />
      )}
    </div>
  );
};

export default GameBoard;
